import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import { vuetifyColors } from '../../../utils/themes.js';
import { localizeDate as _localizeDate, userItemsPerListMixin, isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
import listMixin from '../listMixin';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['title'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDeviceMonitoringList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    accountId: {
      type: Number,
      required: false,
      default: undefined
    },
    filterAlert: {
      type: Boolean,
      required: false,
      default: false
    },
    filterWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    filterThreshold: {
      type: Boolean,
      required: false,
      default: false
    },
    resetFilter: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      isFetching: false,
      range: '1d',
      tableOptions: _objectSpread({}, defaultTableOptions),
      list: [],
      searchItem: null,
      filteredList: [],
      expandedItems: [],
      apiError: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.title'),
          value: 'title'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.eui'),
          value: 'eui'
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceMonitoring.application'),
          value: 'applicationTitle',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceMonitoring.additionalInformation'),
          value: 'additionalInformation',
          sortable: true
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceMonitoring.lastPacket'),
          value: 'createdAt'
        }, {
          sortable: false
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    accountId: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
    }, 500),
    filterAlert: function filterAlert() {
      this.filterList();
    },
    filterWarning: function filterWarning() {
      this.filterList();
    },
    filterThreshold: function filterThreshold() {
      this.filterList();
    },
    resetFilter: function resetFilter() {
      this.resetAllFilter();
    }
  },
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    buildAdditionalInformation: function buildAdditionalInformation(data) {
      var _this = this;

      return data.map(function (item) {
        var infoLine = '';

        if (item.battery_alert_status) {
          infoLine = "".concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.battery'), ": ").concat(item.battery_value.value.toFixed(2), " - ").concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.alertLevel'), ": ").concat(item.variable.alert_level);
        } else if (!item.battery_alert_status && item.battery_warning_status) {
          infoLine = "".concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.battery'), ": ").concat(item.battery_value.value.toFixed(2), " - ").concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.warningLevel'), ": ").concat(item.variable.warning_level);
        } else if (!item.battery_alert_status && !item.battery_warning_status && item.threshold > item.packetCount) {
          infoLine = "".concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.sent'), ": ").concat(item.packetCount, " - ").concat(_this.$i18n_t('NiotaClassic.DeviceMonitoring.threshold'), ": ").concat(item.threshold);
        }

        return _objectSpread(_objectSpread({}, item), {}, {
          additionalInformation: infoLine
        });
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;

      this.isFetching = true;
      NiotaClassicApiService.deviceMonitoring(this.range, this.accountId).then(function (res) {
        _this2.list = _this2.buildAdditionalInformation(res.filteredDevices);

        _this2.filterList();
      }).catch(function (error) {
        // this.$snack(this.$i18n_t('NiotaClassic.DeviceMonitoring.notFound'), 'error');
        _this2.list = [];

        _this2.filterList();

        if (get(error, 'response.data.err') === 'Influx Integration is not activated') {
          // if influx integration is not activated, show error
          _this2.apiError = _this2.$i18n_t('NiotaClassic.DeviceMonitoring.errorInfluxNotActive');
        } else if (error.code === 'ECONNABORTED') {
          // timeouts will display the respective error message
          _this2.apiError = _this2.$i18n_t('NiotaClassic.DeviceMonitoring.errorTimeout');
        } else if (error.response.status !== 404) {
          // other errors than 404 will display 'unknown error' message
          _this2.apiError = _this2.$i18n_t('NiotaClassic.DeviceMonitoring.errorUnknown');
        }
      }).finally(function () {
        _this2.isFetching = false;
      });
    },
    getColor: function getColor(type) {
      return vuetifyColors[type] || vuetifyColors['primary'];
    },
    localizeDate: function localizeDate(item) {
      if (item) {
        return _localizeDate(item);
      }
    },
    filterList: function filterList() {
      // filter by filter Btns
      if (this.filterAlert) {
        this.filteredList = this.list.filter(function (item) {
          return item.battery_alert_status;
        });
      } else if (this.filterWarning) {
        this.filteredList = this.list.filter(function (item) {
          return !item.battery_alert_status && item.battery_warning_status;
        });
      } else if (this.filterThreshold) {
        this.filteredList = this.list.filter(function (item) {
          return !item.battery_alert_status && !item.battery_warning_status && item.threshold > item.packetCount;
        });
      } else {
        this.filteredList = this.list;
      }

      this.$emit('filteredList', this.filteredList);
    },
    resetAllFilter: function resetAllFilter() {
      this.filteredList = this.list;
    },
    getFiltered: function getFiltered(newList) {
      this.$emit('filteredList', newList);
    },
    openDetails: function openDetails(item) {
      this.$router.push("/niota-classic/devices/".concat(item.id, "/details"));
    },
    handleClickDevice: function handleClickDevice(item) {
      if (this.expandedItems.length === 0 || this.expandedItems[0].id !== item.id) {
        this.expandedItems = [item];
      } else {
        this.expandedItems = [];
      }
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    }
  }
};